import styled from '@emotion/styled';

import { formatNairaWithoutDecimal } from '../../../utils/utils';

interface TableMoneyFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
  className?: string;
}

const TableMoneyFormatter: React.FC<TableMoneyFormatterProps> = ({
  data,
  dataKey,
  className,
}) => {
  const label = data && data[dataKey ?? ''];
  return (
    <Container className={className}>
      {formatNairaWithoutDecimal(Number(label ?? 0))}
    </Container>
  );
};

export default TableMoneyFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;
